//@flow
import React from 'react';

import {getDenormalizedListFactory} from 'app/utils/redux_v2';
import {
  buildMultipleDataFetcher,
  buildSingleDataFetcher,
} from 'app/general/datafetchers/builders';
import {convertLocationParamsToFetchParams} from 'app/roles/actions';
import {fetchRolesAndUsers} from 'app/roles/actions';
import type {NormalizedRoleType} from 'app/roles/types';
import type {InfiniteListFetcherProps} from 'app/general/datafetchers/InfiniteListFetcher';
import {InfiniteListFetcher} from 'app/general/datafetchers/InfiniteListFetcher';
import {createImmutableSelector} from 'app/utils/react-utils';
import type {StoreShapeType} from 'app/reducers/types';
import type {StoredResponseType} from 'app/utils/redux_v2';
import {denormalizeRole} from 'app/roles/selectors';

export const denormalizeRolesList =
  getDenormalizedListFactory<NormalizedRoleType>(
    (state) => state.roles,
    createImmutableSelector<
      StoreShapeType,
      StoredResponseType<NormalizedRoleType>,
      any,
      any,
      any
    >(
      (state) => state.userArea.getIn(['usersv2', 'byId']),
      (state, roles) => roles,
      (users, response) => ({
        ...response,
        results: response.results.map((role) => denormalizeRole(users, role)),
      })
    )
  );

export const MultipleStoredRolesFetcher =
  buildMultipleDataFetcher<NormalizedRoleType>(
    convertLocationParamsToFetchParams,
    // $FlowFixMe - flow doesn't understand redux-thunk magic
    fetchRolesAndUsers,
    denormalizeRolesList
  );

export const StoredRoleFetcher = buildSingleDataFetcher<NormalizedRoleType>(
  MultipleStoredRolesFetcher
);

export const RolesInfiniteListFetcher = (
  props: InfiniteListFetcherProps<NormalizedRoleType>
) => (
  <InfiniteListFetcher DataFetcher={MultipleStoredRolesFetcher} {...props} />
);
